module.exports = __webpack_public_path__ + "static/media/angel.c786c47b.png";